import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-gray-900 text-sm font-medium" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500 text-sm font-normal inline-block mt-1"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'CopdMeasurementRow',
  props: {
  label: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number],
    required: true
  },
  alert: {
    type: Boolean,
    default: false
  },
  target: {
    type: String,
    default: null
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      class: _normalizeClass(["p-1.5 align-top text-gray-500 text-sm font-normal", { 'bg-alert-200 rounded-l': __props.alert }])
    }, _toDisplayString(__props.label), 3),
    _createElementVNode("td", {
      class: _normalizeClass(["p-1.5 align-top", { 'bg-alert-200 rounded-r': __props.alert }])
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.value), 1),
      (__props.target)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.target), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})